import React, { useEffect } from "react";
import "./video.css";

const VideoPlayer = window.VideoPlayer;

export function Video({ asset }) {
  useEffect(() => {
    if (window.player) {
      window.player.dispose();
      window.player = null;
    }
    const player = new VideoPlayer(
      "modal-video-js",
      document.getElementById("video-placeholder")
    );
    player.setSource(asset);
    window.player = player;
    return () => {
      window.onclick = function() {};
      window.player.dispose();
      window.player = null;
    }
  }, [ asset ]);

  return (
    <div className="video-container" role="document">
      <div id="video-placeholder" className="modal-video"></div>
    </div>
  );
}